import { create } from 'zustand'
import { UserInfo } from '@/types/apis/user'
import { getToken, removeToken } from '@/utils/user'
import indexApi from '@/apis/index'
import activityApi, { LoginUser } from '@/apis/activity'
// import sensors from 'sa-sdk-javascript'
import { ApiResponse } from '@/types/apis'
import { initSensorsInstance } from '@/hooks/use-sensors'
export type PermissionMap = Record<string, boolean> | null

interface UserState {
  isLoggedIn: boolean
  userInfo: UserInfo | null
  getUserInfoStatus: 'initial' | 'loading' | 'success' | 'failed'
}

// 获取用户信息的 promise
let getLoginUserPromise: Promise<ApiResponse<LoginUser>> | null = null

// 缓存获取用户信息
const getLoginUserInfoCache = async(ignoreCache = false) => {
  if (getLoginUserPromise && !ignoreCache) {
    return getLoginUserPromise 
  }

  getLoginUserPromise = indexApi.getLoginUserInfo()
  const userSource: any = await activityApi.getUserDetailVO()
  try {
    const user: any = await getLoginUserPromise
    if (!user?.data) {
      // 响应为空（如后端返回 null body）时重置缓存，避免后续 getUserAsync() 复用空结果
      getLoginUserPromise = null
    }
    if (user?.data && userSource) {
      user.data.adChannelId = userSource.adChannelId
      user.data.createdAt = userSource?.createdAt
    }
    return user
  } catch (e) {
    getLoginUserPromise = null
    throw e
  }
}

interface UserStore extends UserState {
  setIsLoggedIn: (isLoggedIn: boolean) => void
  setGetUserInfoStatus: (status: UserState['getUserInfoStatus']) => void
  logout: () => void
  getUserAsync: (ignoreCache?: boolean) => Promise<void>
}


export const useUserStore = create<UserStore>(set => ({
  isLoggedIn: !!getToken(),
  userInfo: null,
  getUserInfoStatus: 'initial',

  setIsLoggedIn: isLoggedIn => set({ isLoggedIn }),

  setGetUserInfoStatus: status => set({ getUserInfoStatus: status }),

  logout: () => {
    removeToken()
    set({
      isLoggedIn: false,
      userInfo: null,
      getUserInfoStatus: 'initial'
    })
    getLoginUserPromise = null
  },

  getUserAsync: async ignoreCache => {
    set({ getUserInfoStatus: 'loading' })
    try {
      const res = await getLoginUserInfoCache(ignoreCache)
      const userData = res?.data || {}
      // 用户数据非空时才写入本地存储与神策登录埋点，避免异常路径写入 "undefined" 脏值
      if (userData.uid) {
        localStorage.setItem('user_uid', userData.uid)
        localStorage.setItem('user_phone', userData.mobile)
        initSensorsInstance(sensors => sensors.login(userData.uid))
      }

      set({
        getUserInfoStatus: 'success',
        userInfo: userData
      })
    } catch (error) {
      set({ getUserInfoStatus: 'failed' })
      throw error
    }
  }
}))